import { render, staticRenderFns } from "./MenuPanel.vue?vue&type=template&id=6f04728d&scoped=true&"
import script from "./MenuPanel.vue?vue&type=script&lang=js&"
export * from "./MenuPanel.vue?vue&type=script&lang=js&"
import style0 from "./MenuPanel.vue?vue&type=style&index=0&id=6f04728d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f04728d",
  null
  
)

export default component.exports